/**
 * Lo que escribe un colaborador en el chat del panel, con su formato: negritas, listas, títulos y tablas, en vez
 * de los asteriscos a la vista. Es el mismo lector que usa la pantalla grande (`conversacionLogica`): lo que
 * viene del modelo se pinta como texto, nunca como HTML.
 */
import { bloquesDe, type Bloque, type Trozo } from "./pantalla/conversacionLogica";

export const CSS_DEL_FORMATO = `
.hf { white-space:normal; overflow-wrap:anywhere; }
.hf p { margin:0 0 8px; }
.hf > :last-child { margin-bottom:0; }
.hf h3, .hf h4, .hf h5 { font-size:13px; font-weight:800; margin:10px 0 4px; text-wrap:balance; }
.hf > :first-child { margin-top:0; }
.hf ul, .hf ol { margin:0 0 8px; padding-left:18px; }
.hf li { margin:2px 0; }
.hf blockquote { margin:0 0 8px; padding-left:8px; border-left:2px solid var(--hi-raya-2); color:var(--hi-suave); }
.hf pre { margin:0 0 8px; white-space:pre-wrap; font-size:11.5px; background:var(--hi-fondo); border:1px solid var(--hi-raya); border-radius:6px; padding:6px 8px; }
.hf code { font-size:.92em; background:var(--hi-papel-2); border-radius:3px; padding:0 3px; }
.hf hr { border:0; border-top:1px solid var(--hi-raya); margin:8px 0; }
.hf-tabla { overflow-x:auto; margin:0 0 8px; }
.hf table { border-collapse:collapse; font-size:11.5px; }
.hf th, .hf td { border:1px solid var(--hi-raya); padding:3px 6px; text-align:left; vertical-align:top; }
`;

const Trozos = ({ de }: { de: Trozo[] }) => <>{de.map((x, i) => (x.codigo ? <code key={i}>{x.t}</code> : x.negrita ? <strong key={i}>{x.t}</strong> : x.cursiva ? <em key={i}>{x.t}</em> : <span key={i}>{x.t}</span>))}</>;

function UnBloque({ b }: { b: Bloque }) {
  switch (b.tipo) {
    case "h": return b.nivel === 1 ? <h3><Trozos de={b.trozos} /></h3> : b.nivel === 2 ? <h4><Trozos de={b.trozos} /></h4> : <h5><Trozos de={b.trozos} /></h5>;
    case "ul": return <ul>{b.items.map((it, i) => <li key={i}><Trozos de={it} /></li>)}</ul>;
    case "ol": return <ol>{b.items.map((it, i) => <li key={i}><Trozos de={it} /></li>)}</ol>;
    case "cita": return <blockquote><Trozos de={b.trozos} /></blockquote>;
    case "codigo": return <pre>{b.texto}</pre>;
    case "raya": return <hr />;
    case "tabla": return (
      <div className="hf-tabla"><table>
        <thead><tr>{b.cabecera.map((c, i) => <th key={i}><Trozos de={c} /></th>)}</tr></thead>
        <tbody>{b.filas.map((f, i) => <tr key={i}>{f.map((c, k) => <td key={k}><Trozos de={c} /></td>)}</tr>)}</tbody>
      </table></div>);
    default: return <p><Trozos de={b.trozos} /></p>;
  }
}

export default function Formato({ texto }: { texto: string }) {
  return <div className="hf">{bloquesDe(texto).map((b, i) => <UnBloque key={i} b={b} />)}</div>;
}
